function checkCartLineItems() {
    const cartItems = cartItemsWithPreOrderInfo
    const cartItemsLength = cartItems.length

    cartItems.forEach((cartItem) => {
        const { pre_order_app_information_metafield, properties } = cartItem

        const expectedShippingProperty = pre_order_app_information_metafield.isPreorder
            ? pre_order_app_information_metafield.itemPropertyName
            : 'Shipping Ready';
            
        const currentShippingProperty = properties.find(([key]) => key.includes('Shipping'))?.[0];

        if (expectedShippingProperty !== currentShippingProperty) {
            const newProperties = generateNewProperties(cartItem, expectedShippingProperty);
            updateCartItem(newProperties);
        }
    })
}

function generateNewProperties(cartItem, shippingProperty) {
    const PRESERVE_KEYS = ['_bag_id', '_parent_bag_id'];
    const preserved = Object.fromEntries(
        cartItem.properties.filter(([key]) => PRESERVE_KEYS.includes(key))
    );

    const newProperties = {
        line: cartItem.line,
        properties: {
            ...preserved,
            [shippingProperty]: "1"
        }
    }

    if (cartItem.sale_product) {
        newProperties.properties["Original price"] = cartItem.product_original_price;
        newProperties.properties["On-demand reward"] = cartItem.product_discount;
    }

    return JSON.stringify(newProperties);
}

function updateCartItem(properties) {
    fetch('/cart/change.js', {
        method: 'POST',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: properties,
    })
    .then((res) => {
        if(res.status === 200) {
            console.log('Succesfully updated properties:', properties, res)
        } else {
            console.log('Error updating properties:', res)
        }
    })
    .catch((error) => {
        console.log('Error updating shipping properties:', error)
    })
}

checkCartLineItems()